<div *ngIf="!router.url.includes('/edit/') && !router.url.includes('/add') else childRoutes">

  <msf-list-page-wrapper [leftSize]="flexRowSizes.left" [rightSize]="flexRowSizes.right">
    <div
      left
      #left
      class="requests-content-panel"
      [ngClass]="{'requests-content-panel--map-view': !isWidget && requestsViewTab === 'map'}">
      @if (!isWidget) {
        <div class="page-header">
          <app-back-button
            [title]="'Bids'"
            [ngStyle]="{ 'font-size': isSmallScreen ? '14px' : 'inherit' }"
            parentRoute="/crop-monitoring"
            [subtitle]="('Total' | translate) + ': ' + filteredRequestsCount"
          ></app-back-button>
          <div class="header-actions">
            <app-export-button
              (export)="exportMenu.toggle($event)"
              [loading]="exportLoading"
              [disabled]="exportLoading"
            ></app-export-button>
            <p-menu
              #exportMenu
              [model]="exportMenuItems"
              [popup]="true"
              appendTo="body"
            >
              <ng-template #end>
                <div class="template-export-range">
                  <app-date-picker
                    [ngModel]="templateExportFrom()"
                    (ngModelChange)="templateExportFrom.set($event)"
                    [placeholder]="'Date From' | translate"
                    [showIcon]="true"
                    [showClear]="true"
                    [maxDate]="templateExportTo()"
                    appendTo="self"
                  ></app-date-picker>
                  <app-date-picker
                    [ngModel]="templateExportTo()"
                    (ngModelChange)="templateExportTo.set($event)"
                    [placeholder]="'Date To' | translate"
                    [showIcon]="true"
                    [showClear]="true"
                    [minDate]="templateExportFrom()"
                    appendTo="self"
                  ></app-date-picker>
                  <app-primary-button
                    icon="pi pi-file-excel"
                    title="DOWNLOAD_BID_TEMPLATES"
                    [loading]="templateExportLoading()"
                    [disable]="templateExportDisabled()"
                    (action)="downloadTemplatesByDateRange()"
                  ></app-primary-button>
                </div>
              </ng-template>
            </p-menu>

            @if (!isSmallScreen) {
              <app-primary-button
                icon="pi pi-plus"
                title='Create request'
                (action)="menu.toggle($event)"
              ></app-primary-button>
            } @else {
              <p-button
                *ngIf="isSmallScreen"
                icon="pi pi-plus"
                (click)="menu.toggle($event)"
                styleClass="request-create-btn">
              </p-button>
            }
            <!--            <p-button-->
            <!--              *ngIf="!isSmallScreen"-->
            <!--              [label]="'Create request' | translate"-->
            <!--              icon="pi pi-plus"-->
            <!--              (click)="menu.toggle($event)"-->
            <!--              styleClass="request-create-btn"-->
            <!--            >-->
            <!--            </p-button>-->

            <p-menu
              #menu
              [model]="createRequestMenuItems"
              [popup]="true"
              appendTo="body"
            ></p-menu>
            <p-button
              *ngIf="isSmallScreen"
              icon="pi pi-filter"
              (click)="openFilterModal()"
              styleClass="filter-btn"
            ></p-button>
          </div>
        </div>
      }

      @if (!isWidget) {
        <div class="requests-view-tabs-row">
          <div class="requests-view-tabs" role="tablist">
            <button
              type="button"
              class="requests-view-tab"
              [class.requests-view-tab--active]="requestsViewTab === 'board'"
              (click)="requestsViewTab = 'board'"
              role="tab"
              [attr.aria-selected]="requestsViewTab === 'board'"
            >
              <i class="pi pi-list" aria-hidden="true"></i>
              <span>{{ 'GIS_BIDS_TAB_BOARD' | translate }}</span>
            </button>
            <button
              type="button"
              class="requests-view-tab"
              [class.requests-view-tab--active]="requestsViewTab === 'map'"
              (click)="requestsViewTab = 'map'"
              role="tab"
              [attr.aria-selected]="requestsViewTab === 'map'"
            >
              <i class="pi pi-map" aria-hidden="true"></i>
              <span>{{ 'GIS_BIDS_TAB_MAP' | translate }}</span>
            </button>
          </div>
        </div>
      }

      @if (isWidget || requestsViewTab === 'board') {
        <!--      <div class="requests-count-subtitle">-->
          <!--        <span></span>-->
          <!--      </div>-->
        <div
          class="requests-table-container"
          [class.requests-table-container--loading]="loading">
          <app-dynamic-data-table
            [(loading)]="loading"
            (onRowClick)="editRequest($event)"
            [service]="bidService"
            [getAllMethod]="'cropMonitoringBidCustomGetByQueryPost'"
            [getTotalMethod]="'cropMonitoringBidGetTotalCountPost'"
            [filter]="filtersParams"
            [toggleFilter]="toggleFilter"
            [storageKey]="null"
            [defaultParams]="defaultParams"
            [totalRequestNoSendFilter]="['id']"
            [columns]="
            [
            { field: 'number', header: 'Request number' | translate, type: 'text' },
            { field: 'field', width: '208px', header: 'Field' | translate, type: 'custom', customTemplate: fieldTemplate },
            { field: 'region', width: '160px', header: 'Region' | translate, type: 'custom', customTemplate: regionTemplate },
            { field: 'workPeriod', width: '308px', header: 'Work Period' | translate, type: 'custom', customTemplate: workPeriodTemplate },
            { field: 'bidWorkType', header: 'BID_WORK_TYPE' | translate, type: 'custom', customTemplate: bidWorkTypeTemplate },
            { field: 'status', header: 'Status' | translate, type: 'custom', customTemplate: statusTemplate },
            { field: 'createUser.userName', header: 'Author' | translate, type: 'custom', customTemplate: authorTemplate },
            { field: 'foreman.userName', header: 'Foreman' | translate, type: 'custom', customTemplate: foremanTemplate },
            { field: 'worker.username', header: 'Field worker' | translate, type: 'custom', customTemplate: fieldWorkerTemplate },
            { field: 'crop', header: 'Crop' | translate, type: 'custom', customTemplate: cropTemplate },
            { field: 'anomaliesCount', header: 'Number of anomalies' | translate , type: 'number' },
            { field: '', header: '', type: 'custom', customTemplate: actionsTemplate }
            ]"
          ></app-dynamic-data-table>
        </div>
      }

      @if (!isWidget && requestsViewTab === 'map') {
        <div class="requests-map-panel">
          <app-gis-bids [filtersParams]="filtersParams"></app-gis-bids>
        </div>
      }

      <ng-template #regionTemplate let-row>
        <app-region-display [regionId]="row?.region?.id ?? row?.regionId"></app-region-display>
      </ng-template>

      <ng-template #fieldTemplate let-row>
        <app-field-passport-link [fieldId]="fieldId(row)" [fieldName]="fieldName(row)"/>
      </ng-template>

      <ng-template #workPeriodTemplate let-row>
        <ng-container *ngIf="row.startDate || row.endDate">
          {{ row.startDate | dateFormatLang:translate.currentLang }}
          <ng-container *ngIf="row.endDate && row.startDate">
            - {{ row.endDate | dateFormatLang:translate.currentLang }}
          </ng-container>
          <ng-container *ngIf="row.endDate && !row.startDate">
            - {{ row.endDate | dateFormatLang:translate.currentLang }}
          </ng-container>
        </ng-container>
        <ng-container *ngIf="!row.startDate && !row.endDate">
          --/--/--
        </ng-container>
      </ng-template>

      <ng-template #bidWorkTypeTemplate let-row>
        {{ bidWorkTypesById[row.bidWorkType] | serverTranslate:'names' }}
      </ng-template>

      <ng-template #statusTemplate let-row>
        <app-request-status [statusId]="row.bidState || 0"></app-request-status>
      </ng-template>

      <ng-template #cropTemplate let-row>
        {{ row?.crop | serverTranslate:'names' }}
      </ng-template>

      <ng-template #authorTemplate let-row>
        {{ userNames(row.createUser) }}
      </ng-template>

      <ng-template #foremanTemplate let-row>
        {{ userNames(row.foreman) }}
      </ng-template>

      <ng-template #fieldWorkerTemplate let-row>
        {{ userNames(row.worker) }}
      </ng-template>

      <ng-template #actionsTemplate let-row>
        <div class="flex">
          <button
            pButton
            class="p-button-text p-button-sm edit-button"
            (click)="editRequest(row)"
            pTooltip="Редактировать">
            <img src="../../../../../assets/icons/main/light/edit-2-fill.svg" alt="Edit" class="edit-icon">
          </button>

          @if (resultReady(row)) {
            <div class="result-actions mt-2">
              <img
                alt="Result"
                (click)="$event.stopImmediatePropagation();openRequestResultModal(row.fileResultId)"
                class="cursor-pointer result-action-icon"
                [src]="'doc' | iconPath"
                width="15"
                height="15"
              />
              @if (downloadingPackage[row.fileResultId]) {
                <i class="pi pi-spin pi-spinner result-action-spinner" aria-hidden="true"></i>
              } @else {
                <img
                  alt="Download"
                  (click)="$event.stopImmediatePropagation(); downloadResultPackage(row)"
                  class="cursor-pointer result-action-icon"
                  [src]="'download' | iconPath"
                  width="15"
                  height="15"
                  [pTooltip]="'DOWNLOAD' | translate"
                />
              }
            </div>
          }
        </div>

      </ng-template>
    </div>

    <div right #right *ngIf="!isSmallScreen && !isWidget">
      <msf-filters
        [fields]="requestFilters"
        [(ngModel)]="filters"
        (applyFilter)="applyFilters()"
        (clearFilter)="clearFilters()"
        [isLoading]="loading"
      />
    </div>
  </msf-list-page-wrapper>

  <p-dialog [resizable]="false" [draggable]="false" [(visible)]="isFilterModalOpen" [modal]="true" [closable]="true" [header]="'Filters' | translate">
    <msf-filters
      *ngIf="!isWidget"
      [fields]="requestFilters"
      [(ngModel)]="filters"
      [isLoading]="loading"
      (applyFilter)="applyFilters(); isFilterModalOpen = false"
      (clearFilter)="clearFilters();isFilterModalOpen = false"
    />
  </p-dialog>
</div>

<ng-template #childRoutes>
  <router-outlet></router-outlet>
</ng-template>

<app-request-result-modal #requestResultModal></app-request-result-modal>
